import { Component, ElementRef, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { OpenService } from "@app-services/open.service";
import { LayoutVars, UserInfo } from "@app/store/session/session.store";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";
import { SegmentLabel } from "@app-model/vehicle";
import { ToastrService } from "ngx-toastr";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { SessionService } from "@app/store/session/session.service";
import { MatDialogRef } from "@angular/material/dialog";
import { AcceptNewLoginTermsRequest } from "@app-model/login";
import { Router } from "@angular/router";

@Component({
  selector: 'app-dialog-accept-terms',
  templateUrl: './dialog-accept-terms.component.html',
  styleUrls: ['./dialog-accept-terms.component.scss']
})
export class DialogAcceptTermsComponent implements OnInit {

  layoutVars: LayoutVars;
  form: FormGroup;
  segmentClassification: string[] = [];
  createdSuccessfuly: boolean = false;
  userInfo: UserInfo;

  allSegments = SegmentLabel.allSegments;
  layoutVarsResponse: boolean = false;

  constructor(
    private fb: FormBuilder,
    private openService: OpenService,
    private elRef: ElementRef,
    private toaster: ToastrService,
    private sessionService: SessionService,
    private dialogRef: MatDialogRef<DialogAcceptTermsComponent>,
    private router: Router
  ) {
    this.openService.getLayoutVars()
      .subscribe(layoutVars => {
        this.layoutVars = layoutVars;
        this.layoutVarsResponse = true;
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
      });
  }

  ngOnInit() {
    this.initFormGroup();
    this.toggleSegment('CAR');
    this.sessionService.getUser().subscribe((user) => {
      this.userInfo = user;
    });
  }

  initFormGroup(): void {
    this.form = this.fb.group({
      whatsappNumber: ["", {}],
      whatsappOptin: [false, {}],
      acceptTermsOfUse: [false, [Validators.requiredTrue]]
    });
  }

  submit(): void {
    this.markFormGroupTouched(this.form);
    
    if (!this.form.valid) {
      this.toaster.error("Verifique os campos.");
      return;
    }

    if (!this.segmentClassification || this.segmentClassification.length === 0) {
      this.toaster.error("Escolha pelo menos um segmento");
      return;
    }

    const data: AcceptNewLoginTermsRequest = {
      acceptedNewLogginTerms: true,
      whatsappNumber: this.form.value.whatsappNumber || undefined,
      whatsappOptin: !!this.form.value.whatsappOptin,
      segmentClassification: this.segmentClassification
    };

    this.sessionService.acceptNewLoginTerms(data).subscribe(
      (resp) => {
        this.toaster.success("Termos aceitos com sucesso.");
        this.createdSuccessfuly = true;
        this.dialogRef.close(true);
      },
      (err) => {
        console.error(err);
        this.toaster.error("Ocorreu um erro ao aceitar os termos. Procure o suporte.");
      }
    );
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();
    });
  }

  toggleSegment(segment: string): void {
    if (!this.segmentClassification) {
      this.segmentClassification = [];
    }

    const segmentIdx = this.segmentClassification.indexOf(segment);
    if (segmentIdx < 0) {
      this.segmentClassification.push(segment);
    } else {
      this.segmentClassification.splice(segmentIdx, 1);
    }
  }

  isSegmentSelected(segment: string): boolean {
    return this.segmentClassification && this.segmentClassification.indexOf(segment) >= 0;
  }

  getSegmentLabel(segment: string): SegmentLabel {
    return SegmentLabel.getSegment(segment);
  }

  changeWhatsappOptinStatus(change: MatSlideToggleChange): void {
    if (change.checked) {
      this.form.get('whatsappNumber').setValidators([Validators.required]);
    } else {
      this.form.get('whatsappNumber').clearValidators();
    }
    this.form.get('whatsappNumber').updateValueAndValidity();
  }

  get type(): string {
    return this.form.getRawValue() ? this.form.getRawValue().type : undefined;
  }

  logout(): void {
    this.sessionService.logout();
    this.dialogRef.close(false);
    this.router.navigate(['/logout']);
  }

}
